export const esBodasPalettes = [
  {
    palette: ["#FFF8F0", "#F4D6CC", "#D49A89", "#8C5E58", "#3D3030"],
    paletteName: "Romance atemporal",
    paletteDescription:
      "Marfil, rosa empolvado y terracota crean una celebración cálida, elegante y fácil de adaptar a flores naturales.",
  },
  {
    palette: ["#F8F4EC", "#DCE5D2", "#A8B89F", "#687D68", "#33443A"],
    paletteName: "Jardín silvestre",
    paletteDescription:
      "Verdes suaves y neutros cremosos para una boda natural, relajada y conectada con el exterior.",
  },
  {
    palette: ["#FFFDF8", "#E7D8C9", "#B89B7A", "#8A6A4A", "#2F2924"],
    paletteName: "Arena y lino",
    paletteDescription:
      "Una combinación serena que funciona con lino, madera clara, cerámica artesanal y detalles en latón.",
  },
  {
    palette: ["#F7EEF1", "#D9A7B0", "#A95C68", "#6F3542", "#2D2026"],
    paletteName: "Rosa profundo",
    paletteDescription:
      "Rosados en varias intensidades para una estética romántica con más carácter y profundidad visual.",
  },
  {
    palette: ["#F4F1EA", "#C8D2DC", "#8397A8", "#455A6B", "#1E2933"],
    paletteName: "Azul editorial",
    paletteDescription:
      "Azules grisáceos y marfil para invitaciones, señalética o una celebración de estilo sobrio y contemporáneo.",
  },
  {
    palette: ["#FFF7E8", "#F2D39B", "#C99A3D", "#8C5A22", "#382719"],
    paletteName: "Dorado cálido",
    paletteDescription:
      "Dorado, miel y marrón para una boda nocturna con velas, papelería elegante y detalles metálicos.",
  },
  {
    palette: ["#FFF9F2", "#F5B7A8", "#E88472", "#C24F4A", "#5A2B2D"],
    paletteName: "Atardecer coral",
    paletteDescription:
      "Corales y rojos suaves que aportan energía a una boda de verano sin perder un fondo delicado.",
  },
  {
    palette: ["#F3F0F5", "#CBBBD5", "#9275A5", "#5C416A", "#292332"],
    paletteName: "Lavanda nocturna",
    paletteDescription:
      "Una paleta refinada de violetas apagados, pensada para una celebración íntima y atmosférica.",
  },
  {
    palette: ["#F5F2EA", "#D7D1C6", "#9C9A8E", "#5B665C", "#26352D"],
    paletteName: "Minimalismo botánico",
    paletteDescription:
      "Grises cálidos y verdes oscuros para una identidad nupcial limpia, moderna y natural.",
  },
  {
    palette: ["#FFF5E8", "#F3C28D", "#D87845", "#9E4532", "#4B2924"],
    paletteName: "Terracota festiva",
    paletteDescription:
      "Una mezcla de arcilla, naranja y cacao que se siente cercana, alegre y memorable.",
  },
];
